// ============================================================================
// LE SÉLECTEUR DE PLAGE DE DATES — l'anatomie du panneau « du … au … » et de ses raccourcis.
//
// ⚠️ IL COMPLÈTE UN SEGMENTÉ, IL NE LE REMPLACE PAS. Les crans (Jour / Semaine / Mois / Année) couvrent
// ce qu'on regarde tous les jours ; le sélecteur couvre le reste — et c'est pour ça qu'il est CÔTE À
// CÔTE avec eux et non à leur place. Un segmenté à huit crans casse la largeur de sa piste avant de
// casser le sens (cf. `SegmentedProps`, quatre options au plus).
//
// ⚠️ DEUX CHEMINS DANS LE MÊME PANNEAU, et c'est délibéré : une grille de raccourcis (le geste courant,
// un clic) ET deux champs de date (le cas précis, que jamais aucune liste de raccourcis ne couvrira).
// N'offrir que les raccourcis oblige à en ajouter sans fin ; n'offrir que les champs fait ressaisir
// « hier » à la main tous les matins.
//
// SOURCE : relevé du panneau de bornes du tableau de bord de la maquette back-office (2026-08-18).
// ============================================================================

export const DATE_RANGE = {
  /** Le déclencheur : une pastille, comme la piste de crans qu'il jouxte. */
  trigger: { height: 36, padH: 13, gap: 8, fontSize: 12.5, weight: 600, icon: 15, radius: 'pill' },
  /** ⚠️ `offsetY` relevé sur la maquette (panneau à 44 px sous le haut d'un déclencheur de 36). */
  panel: { width: 330, offsetY: 8 },
  /** Deux colonnes : huit raccourcis tiennent en quatre lignes sans faire défiler le panneau. */
  shortcuts: { cols: 2, gap: 5, pad: 10, height: 32, padH: 10, fontSize: 12, weight: 600, radius: 'ctrl' },
  /** Les bornes libres. ⚠️ Champs en CHIFFRES TABULAIRES : deux dates alignées se comparent d'un coup d'œil. */
  bornes: { padV: 11, padH: 10, gap: 8, labelSize: 10.5, inputHeight: 36, inputPadH: 8, inputSize: 11.5, radius: 'ctrl' },
  /** Le pied porte le RÉSUMÉ de ce qui est demandé — la seule relecture possible avant de valider. */
  foot: { padV: 9, padH: 10, gap: 8, hintSize: 11, btnHeight: 32, btnPadH: 13, ghostPadH: 11, fontSize: 12, radius: 'ctrl' },
} as const;

/**
 * Teintes d'un raccourci selon qu'il est celui en vigueur.
 * ⚠️ Le raccourci ACTIF est bordé ET teinté : sur une grille de huit pastilles claires, un simple
 * changement de fond ne se repère pas — et c'est la seule chose qui dit quelle plage est appliquée.
 */
export const DATE_RANGE_SHORTCUT_TONES = {
  on: { border: 'teal-400', bg: 'teal-100', fg: 'teal-800' },
  off: { border: 'ink-200', bg: 'paper', fg: 'ink-700' },
} as const;
